import { Grid, IconButton, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import AtlasPanel from "../../atlas/blades/AtlasPanel";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import MaterialTable from "material-table";
const ProjectBilling: React.FC<any> = ({ theme, project, billing }) => {
  if (billing === null) return <Fragment />;

  return (
    <MaterialTable
      title="Billing Details"
      columns={[
        { title: "Service", field: "key" },
        { title: "Cost", field: "value" },
      ]}
      data={billing}
      options={{
        showTitle: true,
        grouping: false,
        exportButton: false,
        columnsButton: false,
        search: false,
        pageSize: 5,
        pageSizeOptions: [],
        actionsColumnIndex: -1,
        headerStyle: {
          fontSize: "12px",
          fontWeight: "bold",
          padding: "3px 10px",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          zIndex: 0,
        },
        rowStyle: {
          fontSize: "13px",
        },
      }}
    />
  );
};

export default ProjectBilling;
